import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

/**
 * Shared 24×24 shell for sidebar nav glyphs.
 * Icons use fill="currentColor" so active / hover / inactive colors flow from the sidebar.
 */
export function BaseNavIcon({children, sx, ...rest}: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize="inherit" {...rest} sx={{color: 'inherit', ...sx}}>
      {children}
    </SvgIcon>
  );
}
